import axios, { AxiosError } from 'axios';
import { initLogin } from '.';
import { ResponseStatus } from 'src/constants/apiResponse';

const instance = axios.create({
  baseURL: process.env.REACT_APP_URL,
  // withCredentials: true,
});

export class EarnHttpError {
  message: string;
  code: string | undefined;
  responseBody: string | null;
  status: string | number | undefined;

  constructor(err: AxiosError) {
    this.message = err.message;
    this.code = err.code;
    this.responseBody = err.response?.data as any;
    this.status = err.response?.status;
  }
}

/*

instance.interceptors.request.use(
  async function (config) {
    // Implement some logic before sending the request
    return config;
  },
  function (error) {
    return Promise.reject(error);
  },
);
*/

instance.interceptors.response.use(
  response => response,
  async error => {
    /*
    const status = error.response ? error.response.status : null;
    if (status === ResponseStatus.UNAUTHORIZED) {
      await initLogin(); 
      error.config.baseURL = undefined;
      return axios.request(error.config);
    }
    */
    return Promise.reject(new EarnHttpError(error));
  },
);

export { instance };
